import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayStarPopIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.1 9.35998L20.71 9.04998L19.68 6.86998C19.43 6.34998 18.57 6.34998 18.32 6.86998L17.29 9.04998L14.9 9.35998C14.29 9.41998 14.02 10.24 14.48 10.65L16.23 12.3L15.79 14.67C15.66 15.27 16.36 15.78 16.89 15.47L19 14.32L21.11 15.47C21.64 15.78 22.34 15.27 22.21 14.67L21.77 12.3L23.52 10.65C23.98 10.24 23.71 9.41998 23.1 9.35998ZM20.44 11.49C20.25 11.66 20.17 11.92 20.22 12.17L20.45 13.38L19.37 12.79C19.15 12.67 18.88 12.67 18.65 12.79L17.57 13.38L17.8 12.17C17.85 11.92 17.76 11.66 17.58 11.49L16.68 10.64L17.9 10.48C18.15 10.45 18.37 10.29 18.48 10.06L19.01 8.93998L19.54 10.06C19.65 10.29 19.87 10.45 20.12 10.48L21.34 10.64L20.44 11.49Z"
        fill={color}
      />
      <path
        d="M7.66997 14.47C7.37997 14.65 7.28997 15.04 7.46997 15.33C9.07997 17.91 10.06 20.51 10.38 23.08C10.42 23.42 10.74 23.67 11.08 23.62C11.42 23.58 11.67 23.26 11.62 22.92C11.28 20.17 10.24 17.4 8.52997 14.67C8.34997 14.38 7.95997 14.29 7.66997 14.47Z"
        fill={color}
      />
      <path
        d="M17.54 16.57C15.63 18.62 14.24 20.7 13.42 22.76C13.29 23.08 13.45 23.44 13.77 23.57C14.08 23.7 14.45 23.55 14.58 23.22C15.35 21.3 16.65 19.35 18.46 17.41C18.7 17.16 18.68 16.76 18.43 16.53C18.18 16.3 17.78 16.31 17.55 16.56L17.54 16.57Z"
        fill={color}
      />
      <path
        d="M8.28 21.44L6.28 20.44C5.97 20.28 5.6 20.41 5.44 20.72C5.28 21.03 5.41 21.4 5.72 21.56L7.72 22.56C8.02 22.71 8.4 22.59 8.56 22.28C8.71 21.97 8.59 21.6 8.28 21.44Z"
        fill={color}
      />
      <path
        d="M13.1 4.91002L9.32001 4.42002L7.69001 0.970017C7.44001 0.450017 6.58001 0.450017 6.33001 0.970017L4.70001 4.42002L0.920014 4.91002C0.310014 4.97002 0.0400141 5.79002 0.500014 6.20002L3.27001 8.82002L2.57001 12.57C2.44001 13.17 3.14001 13.68 3.67001 13.37L7.02001 11.54L10.37 13.37C10.9 13.68 11.6 13.17 11.47 12.57L10.77 8.82002L13.54 6.20002C14 5.79002 13.73 4.97002 13.12 4.91002H13.1ZM9.41001 8.01002C9.22001 8.18002 9.14001 8.44002 9.19001 8.69002L9.68001 11.29L7.36001 10.02C7.14001 9.90002 6.87001 9.90002 6.64001 10.02L4.32001 11.29L4.81001 8.69002C4.86001 8.44002 4.77001 8.18002 4.59001 8.01002L2.67001 6.19002L5.29001 5.85002C5.54001 5.82002 5.76001 5.66002 5.87001 5.43002L7.00001 3.04002L8.13001 5.43002C8.24001 5.66002 8.46001 5.82002 8.71001 5.85002L11.33 6.19002L9.41001 8.01002Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayStarPopIcon.displayName = 'PayStarPopIcon';
